<template>
      <transition name="fade">
  <div v-if="showPopup" class="name-popup">
    <h2>Completa il tuo Profilo</h2>
    <p>Cosi da essere sempre più veloci e precisi nelle risposte.</p>
    <form @submit.prevent="updateName">
      <input type="text" v-model="name" placeholder="Nome" />
      <input type="text" v-model="surname" placeholder="Cognome" />
      <button type="submit">Salva</button>
    </form>
  </div>
</transition>
</template>

<script>
import { ref, onUnmounted } from 'vue';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export default {
  setup() {
    const auth = getAuth();
    const user = auth.currentUser;
    const db = getFirestore();
    const name = ref('');
    const surname = ref('');
    const showPopup = ref(false);

    // Controlla se il nome e cognome sono mancanti e mostra il popup
    const checkUserInfo = async () => {
    if (user && (!user.displayName || !user.surname)) {
      setTimeout(() => {
        if (!unmounted.value) { // Controlla se il componente è ancora montato
          showPopup.value = true;
        }
      }, 1000); // Ritardo di 1 secondo
    }
  };

    const updateName = async () => {
      const userDocRef = doc(db, 'users', user.uid);
      await updateDoc(userDocRef, {
        name: name.value,
        surname: surname.value
      });

      showPopup.value = false;
      // Aggiorna le informazioni dell'utente se necessario
    };

    
    checkUserInfo();

    const unmounted = ref(false);
  onUnmounted(() => {
    unmounted.value = true;
  });

    return {
      name,
      surname,
      showPopup,
      updateName,
      unmounted
    };
  }
};
</script>

<style scoped>

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}


.name-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: rgb(123, 0, 0);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.6);
  color:#ffffff;
  padding: 30px;
  width: 100%;
  max-width: 240px;
  border-radius: 10px;
  text-align: center; /* Aggiunto per centrare il testo e gli elementi inline o inline-block */
}

input[type="text"]{
margin-top: 10px;
width: 170px;
padding: 17px;
  border-radius: 17px;
  margin-left: auto;
  margin-right: auto;
}

button {
  width: 100%; /* Larghezza piena per input e button */
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
  display: block; /* Rende gli elementi block per permettere margin auto */
  margin-left: auto;
  margin-right: auto;
}

button {
  padding: 15px 20px;
  background-color: #1d1d1d;
  color: white;
  border: none;
  border-radius: 17px;
  cursor: pointer;
  width: 50%;
}

button:hover {
  background-color: #0056b3;
}
</style>


